import { useEffect, useState } from 'react';
import { ACSApi, ToastStateHandler } from '../../../api';
import { useContainer } from '../../useContainer';
import { AbsentColleaguesDto } from '../../../commonTypes/acs/user.types';
import { useTranslation } from '../../useTranslation';

const useHttpGetAbsentColleaguesOnMount = () => {
    const { t } = useTranslation('newNotifications');
    const acsApi: ACSApi = useContainer(ACSApi);
    const [isReady, setIsReady] = useState(false);
    const [data, setData] = useState<AbsentColleaguesDto[]>([]);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    useEffect(() => {
        const { exec, abort } = acsApi.getAbsentColleagues({
            onSuccess: res => setData(res.body),
            onError: _ => toastHandler.push('error', t('common.error'), t('common.somethingWentWrong')),
            onFinally: () => setIsReady(true),
        });
        exec();
        return abort;
    }, []);
    return { isReady, data };
};

export default useHttpGetAbsentColleaguesOnMount;
